import React, {useEffect, useLayoutEffect, useState} from "react";
import {Badge, Button, ButtonGroup} from "react-bootstrap";
import {withNamespaces} from "react-i18next";

const NetworkDeviceTypeSwitcher = (
    {
        t,
        uniqDeviceType,
        networkDeviceList,
        statusActiveElement,
        enabledDeviceGroup,
        enabledArea,
        areas,
        selectedArea,
        deviceGroupList,
        selectedDeviceGroup,
        activeElement = 0,
        onChangeDeviceType,
        onChangeStatusType,
        onChangeArea,
        onChangeDeviceGroup
    }) => {


    const countDeviceType = uniqDeviceType?.length;
    const hasArea = areas?.length;
    const selectedAreaModel = areas?.find((item) => item.id === selectedArea);

    if(selectedAreaModel) {
        // console.log(selectedAreaModel.inclx);
    }

    if(selectedDeviceGroup) {

    }


    const filterOnline = (args) => {
        return args
    };

    const useWindowsSize = () => {
        const [size, setSize] = useState([0, 0]);
        useLayoutEffect(() => {
            const updateSize = () => {
                setSize([window.innerWidth, window.innerHeight]);
            }
            window.addEventListener("resize", updateSize);
            updateSize();
            return () => window.removeEventListener("resize", updateSize);
        }, []);
        return size;
    }

    const [width, height] = useWindowsSize();

    return (
        countDeviceType > 0 ? (
            <React.Fragment>
                <div className="row">
                    <div className="col-6 col-lg-12">
                        <h6>{ t('device-type') }</h6>
                        <ButtonGroup vertical={width < 999}>
                            {/* button all */}
                            <Button
                                variant={"outline-primary"}
                                size={"sm"}
                                active={activeElement === 0}
                                onClick={() => onChangeDeviceType(0)}
                            >
                                { t('all-device-type') }
                            </Button>
                            {/* buttons all devices */}
                            { uniqDeviceType.map((buttonModel, idx)=> {
                                return (
                                    <Button
                                        key={idx}
                                        variant={"outline-primary"}
                                        size={"sm"}
                                        active={activeElement === buttonModel.item.id}
                                        onClick={() => onChangeDeviceType(buttonModel.item.id)}
                                    >
                                        { buttonModel.item.label } &nbsp;
                                        <Badge pill={true} variant={"success"}>{
                                            buttonModel.count
                                        }</Badge>
                                    </Button>
                                )
                            }) }
                        </ButtonGroup>
                    </div>
                    <div className="col-6 col-lg-12">
                        <h6>{ t('status') }</h6>
                        <ButtonGroup vertical={width < 990}>
                            <Button
                                variant={"outline-primary"}
                                size={"sm"}
                                active={statusActiveElement ===  null}
                                onClick={() => onChangeStatusType(null)}
                            >
                                { t('all') } &nbsp;

                                { selectedDeviceGroup ? (
                                    <Badge pill={true} variant={"primary"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => x.deviceType.id === activeElement && x.deviceGroupIds.includes(selectedDeviceGroup))?.length :
                                            networkDeviceList?.filter((x) => x.deviceGroupIds.includes(selectedDeviceGroup))?.length
                                    }</Badge>
                                ) : (
                                    <Badge pill={true} variant={"primary"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => x.deviceType.id === activeElement)?.length :
                                            networkDeviceList?.length
                                    }</Badge>
                                ) }

                            </Button>

                            <Button
                                variant={"outline-success"}
                                size={"sm"}
                                active={statusActiveElement ===  true}
                                onClick={() => onChangeStatusType(true)}
                            >
                                { t('online') } &nbsp;

                                {selectedDeviceGroup ? (
                                    <Badge pill={true} variant={"success"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => (x.isOnline === true && x.isOnlineNetwork === true) && x.deviceType.id === activeElement && x.deviceGroupIds.includes(selectedDeviceGroup))?.length :
                                            networkDeviceList?.filter((x) => (x.isOnline) === true && x.isOnlineNetwork === true && x.deviceGroupIds.includes(selectedDeviceGroup))?.length
                                    }</Badge>
                                ) : (
                                    <Badge pill={true} variant={"success"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => (x.isOnline === true && x.isOnlineNetwork === true) && x.deviceType.id === activeElement)?.length :
                                            networkDeviceList?.filter((x) => (x.isOnline) === true && x.isOnlineNetwork === true)?.length
                                    }</Badge>
                                )}

                            </Button>

                            <Button
                                variant={"outline-danger"}
                                size={"sm"}
                                active={statusActiveElement ===  false}
                                onClick={() => onChangeStatusType(false)}
                            >
                                { t('offline') } &nbsp;

                                {selectedDeviceGroup ? (
                                    <Badge pill={true} variant={"danger"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => (x.isOnline === false && x.isOnlineNetwork === false) && x.deviceType.id === activeElement && x.deviceGroupIds.includes(selectedDeviceGroup))?.length :
                                            networkDeviceList?.filter((x) => x.isOnline === false && x.isOnlineNetwork === false && x.deviceGroupIds.includes(selectedDeviceGroup))?.length
                                    }</Badge>
                                ) : (
                                    <Badge pill={true} variant={"danger"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => (x.isOnline === false && x.isOnlineNetwork === false) && x.deviceType.id === activeElement)?.length :
                                            networkDeviceList?.filter((x) => x.isOnline === false && x.isOnlineNetwork === false)?.length
                                    }</Badge>
                                )}

                            </Button>

                            <Button
                                variant={"outline-warning"}
                                size={"sm"}
                                active={statusActiveElement ===  'warning'}
                                onClick={() => onChangeStatusType('warning')}
                            >
                                { t('warning') } &nbsp;
                                {selectedDeviceGroup ? (
                                    <Badge pill={true} variant={"warning"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => ((x.isOnline === false && x.isOnlineNetwork === true) || (x.isOnline === true && x.isOnlineNetwork === false)) && x.deviceType.id === activeElement && x.deviceGroupIds.includes(selectedDeviceGroup))?.length :
                                            networkDeviceList?.filter((x) => (x.isOnline === false && x.isOnlineNetwork === true) || (x.isOnline === true && x.isOnlineNetwork === false) && x.deviceGroupIds.includes(selectedDeviceGroup)).length
                                    }</Badge>
                                ) : (
                                    <Badge pill={true} variant={"warning"}>{
                                        activeElement !== 0 ?
                                            networkDeviceList?.filter((x) => ((x.isOnline === false && x.isOnlineNetwork === true) || (x.isOnline === true && x.isOnlineNetwork === false)) && x.deviceType.id === activeElement)?.length :
                                            networkDeviceList?.filter((x) => (x.isOnline === false && x.isOnlineNetwork === true) || (x.isOnline === true && x.isOnlineNetwork === false))?.length
                                    }</Badge>
                                ) }

                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
                { enabledArea ? (
                    <div className="row">
                        <div className="col">
                            <h6>{t('area')}</h6>
                            <ButtonGroup>
                                <Button
                                    size={"sm"}
                                    variant={"outline-primary"}
                                    active={selectedArea === null}
                                    onClick={() => onChangeArea(null)}
                                >
                                    {t('all')}
                                </Button>
                                { areas ? (
                                    areas.map((item, idx) => {
                                        return (
                                            <Button
                                                key={idx}
                                                size={"sm"}
                                                variant={"outline-primary"}
                                                active={selectedArea === item.id}
                                                onClick={() => onChangeArea(item.id)}
                                            >
                                                {item.label}
                                            </Button>
                                        )
                                    })
                                ) : (
                                    <React.Fragment/>
                                ) }
                            </ButtonGroup>
                        </div>
                    </div>
                ) : (<React.Fragment/>) }

                { enabledDeviceGroup ? (
                    <div className="row">
                        <div className="col-6 col-lg-12">
                            <h6>{t('device-group')}</h6>
                            <ButtonGroup vertical={width < 999}>
                                <Button
                                    size={"sm"}
                                    variant={"outline-primary"}
                                    active={selectedDeviceGroup === null}
                                    onClick={() => onChangeDeviceGroup(null)}
                                >
                                    {t('all')}
                                </Button>
                                { deviceGroupList?.map((group, idx) => {
                                    return (
                                        <Button
                                            key={idx}
                                            size={"sm"}
                                            variant={"outline-primary"}
                                            active={selectedDeviceGroup === group.id}
                                            onClick={() => onChangeDeviceGroup(group.id)}
                                        >
                                            {group.label}
                                        </Button>
                                    )
                                }) }
                            </ButtonGroup>
                        </div>
                    </div>
                ) : (<React.Fragment/>) }

            </React.Fragment>
        ) : (
            <React.Fragment/>
        )
    )
};
export default withNamespaces()(NetworkDeviceTypeSwitcher);
